<template>
  <Catalog
    title="Подразделение"
    name-label="Название"
    submit-error="Укажите название подразделения."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :min-name-length="2"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "Department",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getDepartmentById(id);
    },
    async putData(data) {
      return await this.putDepartment(data)
    },
    async postData(data) {
      return await this.postDepartment(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Departments/Department.vue